<template>
  <div>
    <Sticky>
      <nav
        class="navbar navbar-horizontal navbar-expand-lg"
        style="background: linear-gradient(to right, #1a5fb4 0%, #2590ed 50%, #1a5fb4 100%);"
      >
        <div class="container-fluid">
          <div
            class="navbar-brand text-white"
            :class="
              $route.path !== '/home' ? 'd-flex justify-content-between' : ''
            "
          >
            <div
              class="d-flex flex-column banking-icons my-auto ml-1 mr-3"
              v-if="$route.path !== '/auth/login'"
            >
              <i
                class="fas fa-chevron-left mx-auto my-1 text-xl text-white"
                @click="
                  $playSound();
                  $router.go(-1);
                "
                v-if="$route.path !== '/home'"
              ></i>
            </div>
            <img
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/doubleT/doubleTlogo-removebg-preview%20(1).png"
              alt=""
              @click="
                $playSound();
                $router.push('/home');
              "
            />
            <!-- LOGO -->
          </div>
          <div class="d-flex">
            <!-- Refresh  -->
            <!-- <div
              class="navbar-brand text-white mx-3 d-flex flex-column"
              @click="$router.go()"
            >
              <i class="fas fa-redo mx-auto"></i>
              <div>
                {{ $store.state.language === 'en' ? 'Refresh' : 'Refresh' }}
              </div>
            </div> -->
            <div
              class="d-flex"
              v-if="$route.path !== '/auth/login' && authUser"
            >
              <span class="my-auto pr-3" style="border-right: 1px solid gray">
                <span class="text-sm text-uppercase" style="color: #b7aaaa">
                  <img
                    loading="lazy"
                    class="coin"
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/hulk333/coin.png"
                    alt=""
                  />
                </span>
                <span class="text-white text-md">
                  <b>{{
                    Number($store.state.authUser.amount).toLocaleString()
                  }}</b>
                </span>
              </span>
            </div>

            <!-- Language -->
            <div
              class="nav-link d-flex justify-content-between"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div id="navbar-language">
                <img
                  :src="$t('images.lang-img')"
                  alt=""
                  class="mr-2"
                  style="width: 25px; height: 25px"
                />
              </div>
            </div>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="navbar-language"
            >
              <a class="dropdown-item" @click="setLangLocalstorage('en')"
                ><img
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/united-kingdom%20(1).png"
                  alt=""
                  class="mr-2"
                  style="width: 20px; height: 20px"
                />
                {{ $t("en") }}</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" @click="setLangLocalstorage('mm')"
                ><img
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/myanmar_.png"
                  alt=""
                  class="mr-2"
                  style="width: 20px; height: 20px"
                />{{ $t("mm") }}</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" @click="setLangLocalstorage('cn')"
                ><img
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china%20(1).png"
                  alt=""
                  class="mr-2"
                  style="width: 20px; height: 20px"
                />{{ $t("cn") }}</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" @click="setLangLocalstorage('th')"
                ><img
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand%20(1).png"
                  alt=""
                  class="mr-2"
                  style="width: 20px; height: 20px"
                />{{ $t("th") }}</a
              >
            </div>
          </div>
        </div>
      </nav>
    </Sticky>
  </div>
</template>
<script>
import { Toast, Dialog, Sticky } from "vant";
import { mapActions } from "vuex";

export default {
  components: { Sticky },
  data() {
    return {
      // imageLink: `https://ui-avatars.com/api/?name=${this.$store.state.authUser.email}&background=0D8ABC&color=fff`,
      isLogged: false,
      authUser: null,
      alreadyGranted: true,
    };
  },
  methods: {
    ...mapActions(["logoutUser", "fetchUser"]),
    askNotificationPermission() {
      Notification.requestPermission().then(async (permission) => {
        if (permission === "granted") {
          this.alreadyGranted = false;
          alert(
            this.$store.state.language === "en"
              ? "Notification permission granted!"
              : "အသိပေးချက်အတည်ပြုပြီးပြီ",
          );
        } else {
          alert(
            this.$store.state.language === "en"
              ? "Notification permission denied!"
              : "အသိပေးချက်အတည်ပြုမပြီးပြီ",
          );
        }
      });
    },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === "en"
            ? "Are you sure to log out?"
            : "ထွက်မှာ သေချာပါသလား?",
        cancelButtonText:
          this.$store.state.language === "en" ? "Cancel" : "မထွက်တော့ပါ",
        confirmButtonText:
          this.$store.state.language === "en" ? "Sure" : "သေချာပြီ",
      })
        .then(async () => {
          await this.logoutUser();
          if (this.$route.path === "/home") {
            this.$router.go();
          } else {
            this.$router.push("/home");
            this.$router.go();
          }
          Toast.success(
            this.$store.state.language === "en" ? "Logged out!" : "ထွက်ပြီးပြီ",
          );
        })
        .catch(() => {});
    },
    closeNavCollapse() {
      $("#navbar-default").collapse("hide");
    },
    setLangLocalstorage(language) {
      localStorage.setItem("language", language);
      this.$store.commit("setLanguage", language);
      this.$i18n.locale = language;
      $("#navbar-default").collapse("hide");
    },
    redirectLink(link) {
      this.$router.push(`/${link}`).catch(() => {});
      $("#navbar-default").collapse("hide");
    },
    redirectRoute(path) {
      if (path === "2d") {
        this.$router.push("/user/2d");
      } else {
        this.$router.push("/user/3d");
      }
      return true;
    },
  },
  async mounted() {
    if (window.Notification.permission === "granted") {
      this.alreadyGranted = false;
    }

    this.authUser = await this.fetchUser();
    if (this.authUser) {
      this.isLogged = true;
    }
  },
};
</script>
<style scoped>
.coin {
  height: 1.3rem;
  margin-top: -0.25rem;
  margin-right: 0.4rem;
  animation: flip-coin-49989627 2.5s linear infinite;
  animation-delay: 0s;
  animation-direction: normal;
  animation-fill-mode: none;
  animation-play-state: running;
  transform-style: preserve-3d; /* Keeps the 3D effect */
}

/* Define the keyframes for the 3D flip animation */
@keyframes flip-coin-49989627 {
  0% {
    transform: rotateY(0deg); /* Front face */
  }
  50% {
    transform: rotateY(180deg); /* Back face */
  }
  100% {
    transform: rotateY(360deg); /* Front face again */
  }
}

/* CSS */
.login-btn {
  background: transparent;
  border: 1px solid #d02126;
  border-radius: 3px;
  padding: 0.3rem 1.5rem;
  color: #d02126;
}

.navbar {
  padding: 6px 12px;
  padding-left: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
  /* border-bottom: 2px solid black; */
}
.navbar-horizontal .navbar-brand img {
  height: 40px;
}
.nav-link {
  cursor: pointer;
}
.navbar-brand.brand-text {
  font-size: 20px;
  color: red;
  margin-left: 0px;
  margin-right: 10px;
}
.navbar-brand {
  font-size: 16px;
  margin-left: 20px;
  margin-right: 20px;
  cursor: pointer;
}
.dropdown-item {
  cursor: pointer;
}
.bg-default {
  background-color: #02133e !important;
}
@media (max-width: 767.98px) {
  .navbar-brand {
    font-size: 14px;
    margin-left: 0px;
    margin-right: 0px;
  }
}
</style>
